import { Box, Typography } from "@mui/material";
import { useState, useEffect, useCallback } from "react";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import dashboardAtoms, { fetchBlocks, fetchMapRender } from "../../../../atoms/Dashboard/DashboardAtom";
import LayoutComponent from "../../../../components/dashboard/Layout";
import settingsAtom from "../../../../atoms/settings/SettingsAtom";
import ToggleButtonComponent from "../../../../shared/Dashboard/ToogleButton";
import LogsChecklistRightPanel from "./rightPanel";
import punchListAtom, { fetchDownloadAuditLogsAtom, fetchGenerateNewITRAtom, fetchReportsData } from "../../../../atoms/quality/QualityAtoms";
import GenerateNewITRModal from "./generateNewITRModal";
import TableComponent from "./TableComponent";
import { ItcandItrColumns } from "../../../../shared/constent/constent";


const Mapview = () => {
    const projectId = localStorage.getItem("project_id");
    const navigate = useNavigate();

    const [data] = useAtom(dashboardAtoms);
    const [settings] = useAtom(settingsAtom);
    const [reportData] = useAtom(punchListAtom)
    const [, setMap] = useAtom(fetchMapRender)
    const [, setBlocks] = useAtom(fetchBlocks);
    const [, setDownloadAuditLogs] = useAtom(fetchDownloadAuditLogsAtom);
    const [, setTableValue] = useAtom(fetchReportsData)
    const [selectPart, setSelectPart] = useState([])
    const [loader, setLoader] = useState(false)
    const [view, setView] = useState("Logs");
    const [selectBlock, setSelectBlock] = useState(false);
    const [isSelect, setIsSelect] = useState(true);
    const [isSelectAll, setIsSelectAll] = useState(false)
    const [showGenerateNewITRModal, setShowGenerateNewITRModal] = useState(false)
    const [modalLoader, setModalLoader] = useState(false);
    const [formData, setFormData] = useState({
        visibility: 'internal',
        itcModule: '',
        itrReferenceNumber: '',
    });
    const [, setGenerateITR] = useAtom(fetchGenerateNewITRAtom);
    const updateFormField = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };
    const [type, setType] = useState("ITC");
    const [visibility, setVisibility] = useState("external")
    const [initialFilter, setInitialFilter] = useState({})
    const [currentFilter, setCurrentFilter] = useState({
        block: [],
        row: [],
        scope: [],
        section: [],
    });
    const [list, setList] = useState({
        block: [],
        row: [],
        scope: [],
        section: [],
    });

    const [paginationModel, setPaginationModel] = useState({
        pageSize: 10,
        page: 0,
    });
    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState([]);
    const { tableData = [] } = reportData;

    useEffect(() => {
        if (view === "Lock/Unlock") {
            navigate("/quality/lock-and-unlock")
        }
        // eslint-disable-next-line
    }, [view])


    useEffect(() => {
        if (tableData?.filter_values && filters?.length === 0) {
            setInitialFilter(tableData.filter_values);
            setList(tableData.filter_values);
            setCurrentFilter(
                {
                    block: [],
                    row: [],
                    scope: [],
                    section: [],
                }
            )
        } else if (filters?.length) {
            const filterKeys = filters
                .map(f => Object.keys(f)[0])
                .filter((_, index) => index === 0)

            const resetFilterValues = filterKeys.reduce((acc, key) => {
                acc[key] = initialFilter[key];
                return acc;
            }, {});

            setList({
                ...tableData.filter_values,
                ...resetFilterValues,
            });

            setCurrentFilter(tableData.filter_values)

        }
    }, [tableData, filters, initialFilter]);

    const fetchAllData = useCallback(async () => {
        setLoader(true)
        try {
            await Promise.allSettled([
                setBlocks(''),
                setMap(''),
            ]);
        } catch (error) {
            console.error("Error in fetchAllData:", error);
        } finally {
            setLoader(false)
        }
        // eslint-disable-next-line
    }, [setBlocks, setMap]);

    const handleClickSelectAll = () => {
        setIsSelectAll(true)
    };

    const handleClearSelection = () => {
        // Always clear the selected parts
        setSelectPart([]);

        // Clear the selectAll flag if it's set
        if (isSelectAll === true) {
            setIsSelectAll(false)
        }
    };

    console.log(filters)

    const handleGenerateNewITR = async () => {
        setModalLoader(true);
        try {

            await setGenerateITR({
                punchlistType: formData.visibility,
                referenceNumber: formData.itrReferenceNumber,
                module: formData.itcModule
            });
            setFormData({
                visibility: 'internal',
                itcModule: '',
                itrReferenceNumber: '',
            })
            handleCloseGenerateNewITRModal()
        } catch (error) {
            console.error("Error generating new ITR:", error);
        } finally {
            setModalLoader(false);
        }
    };

    // Download functions
    const handleDownloadCPLog = async () => {
        try {
            if (selectPart.length > 0) {
                await setDownloadAuditLogs({ activity_type: "cp", block_ids: selectPart })
            }
            else {
                await setDownloadAuditLogs({ activity_type: "cp" })
            }
        } catch (error) {
            console.error("Error downloading CP log:", error);
        }
    };

    const handleDownloadQCLog = async () => {
        try {
            if (selectPart.length > 0) {
                await setDownloadAuditLogs({ activity_type: "qc", block_ids: selectPart })
            }
            else {
                await setDownloadAuditLogs({ activity_type: "qc" })
            }
        } catch (error) {
            console.error("Error downloading QC log:", error);
        }
    };

    const handleGenerateAndDownloadITR = async () => {
        setOpen(true)
    };

    const handleOpenGenerateNewITRModal = async () => {
        setShowGenerateNewITRModal(true);
    };

    const handleCloseGenerateNewITRModal = () => {
        setShowGenerateNewITRModal(false);
    };
    // Download buttons configuration
    const downloadButtons = [
        {
            id: 'cp-log',
            label: 'Download CP log',
            handler: handleDownloadCPLog,
            disabled: false
        },
        {
            id: 'qc-log',
            label: 'Download QC log',
            handler: handleDownloadQCLog,
            disabled: false
        },
        {
            id: 'new-itr',
            label: 'Generate ITR',
            handler: handleOpenGenerateNewITRModal,
            disabled: selectPart.length === 0
        },
        {
            id: 'itr',
            label: 'Download ITC and ITR',
            handler: handleGenerateAndDownloadITR,
            disabled: false
        }
    ];


    useEffect(() => {
        if (projectId) {
            fetchAllData();
        }
    }, [projectId, fetchAllData]);


    return (
        <Box sx={{ height: 'calc(100vh - 200px)', width: "100%", p: 0 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "start", py: 2, px: 2 }}>
                <Typography variant="span" fontSize={22} sx={{ fontWeight: "bold" }}>
                    Logs and Checklists</Typography>
                <ToggleButtonComponent
                    data={["Lock/Unlock", "Logs"]}
                    active={view}
                    setActive={setView}
                />
            </Box>

            <Box px={4} sx={{ borderTop: '1px solid #e0e0e0', display: "flex" }}>
                <Box sx={{ width: "65%", borderRight: '1px solid #e0e0e0' }}>
                    {loader ?
                        <Box sx={{
                            height: 'calc(100vh - 265px)',
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <CircularProgress />
                        </Box>
                        : <LayoutComponent
                            svgMap={data?.svgMap}
                            loader={loader}
                            blocks={data?.blocks}
                            list={data?.list}
                            projectList={settings?.projectList}
                            selectBlock={selectBlock}
                            setSelectBlock={setSelectBlock}
                            selectPart={selectPart}
                            setSelectPart={setSelectPart}
                            isSelect={isSelect}
                            setIsSelect={setIsSelect}
                            type="logs and checklists"
                            selectAll={isSelectAll}
                        />
                    }
                </Box>
                <Box sx={{ width: '35%' }} p={2}>
                    <LogsChecklistRightPanel
                        onSelectAll={handleClickSelectAll}
                        onClearSelection={handleClearSelection}
                        selectPart={selectPart}
                        isSelectAll={isSelectAll}
                        selectAllButtonText="Select All"
                        downloadButtons={downloadButtons}
                        mode="logs"
                    />
                </Box>
                <GenerateNewITRModal
                    open={showGenerateNewITRModal}
                    onClose={handleCloseGenerateNewITRModal}
                    formData={formData}
                    updateFormField={updateFormField}
                    loading={modalLoader}
                    onProceed={handleGenerateNewITR}
                />

                <TableComponent
                    open={open}
                    onClose={() => setOpen(!open)}
                    type={type}
                    setType={setType}
                    visibility={visibility}
                    setVisibility={setVisibility}
                    data={reportData?.tableData?.data}
                    columns={ItcandItrColumns}
                    list={list}
                    setList={setList}
                    currentFilterValue={currentFilter}
                    setCurrentFilterValue={setCurrentFilter}
                    paginationModel={paginationModel}
                    setPaginationModel={setPaginationModel}
                    filters={filters}
                    setFilters={setFilters}
                    initialFilter={initialFilter}
                    setTableValue={setTableValue}
                />
            </Box>
        </Box>
    );
};

export default Mapview;